import { Tag } from "./tag";
export class TagGroup {
  constructor(
    public isGeneral: boolean,
    public id: number,
    public name: string,
    public tags: Tag[],
  ) {
  this.tags.sort((a, b) => {
      return b.name.localeCompare(a.name) * -1
    })
  }
}
